module.exports = __webpack_public_path__ + "img/train-subway-tunnel.bd2f4c0f.svg";